<script>
export default {
  props: ['value', 'title', 'subtitle'],
  data() {
    return {
      requestedFund: 0,
      categories: [
        {'name': 'Software Development', 'id': 1},
        {'name': 'Product Development', 'id': 2},
        {'name': 'Business Development', 'id': 3}
      ],
      fundUseList: [{
        'label': 'Product Development',
        'code': 'product_development',
        'value': 0,
      }, {
        'label': 'Sales and Marketing',
        'code': 'sales_marketing',
        'value': 0,
      }, {
        'label': 'Operations',
        'code': 'operations',
        'value': 0,
      }, {
        'label': 'Others',
        'code': 'others',
        'value': 0,
      }]
    }
  },
  mounted() {
    if (this.value && Object.keys(this.value).length > 0 && this.value.fundUseList && this.value.requestedFund) {
      this.fundUseList = this.value.fundUseList;
      this.requestedFund = this.value.requestedFund;
    }
    else {
      // default value
      this.$emit('input', {
        fundUseList: this.fundUseList,
        requestedFund: this.requestedFund,
      });
    }
  },
  methods: {
    remove(index) {
      this.fundUseList.splice(index, 1)
    },
    isCategorySelected(category) {
      return this.fundUseList.filter((item) => {
        return item.category === category
      }).length > 0;
    },
    isAllSelected() {
      let selected = 0;
      for (let cat of this.categories) {
        for (let item of this.fundUseList) {
          if (item.category === cat.id) {
            selected++;
          }
        }
      }

      return selected === this.categories.length;
    },
    updateWithSum() {
      let sum = 0;
      for (let item of this.fundUseList) {
        sum += item.value;
      }
      this.requestedFund = sum;
    }
  },
  computed: {
    total() {
      let sum = 0;
      for (let item of this.fundUseList) {
        if (item.value) {
          sum += parseFloat(item.value);
        }
      }

      return sum;
    }
  },
  watch: {
    fundUseList(newVal, oldVal) {
      this.$emit('input', {
        fundUseList: newVal,
        requestedFund: this.requestedFund,
      });
    },
    requestedFund(newVal, oldVal) {
      this.$emit('input', {
        fundUseList: this.fundUseList,
        requestedFund: newVal,
      });
    },
  }
};
</script>

<template>
  <div>
    <div class="fund-use-input">
      <div class="title-md">
       {{title}}
      </div>
      <div class="sep-16"></div>
         <div>
        <div class="field">
          <input type="hidden" vrules="required" name="fund-user-validation" :value="total !== requestedFund? ' ': 1">
          <div class="vrule " style="color: red" rule="required" v-if="total !== requestedFund">
            Use of fund categories total must be equal to the requested fund value.
          </div>
        </div>

      </div>
      <div class="field">

        <div class="icon-control">
          <div class="icon-input">$</div>
          <input id="requested-fund" type="number" vrules="required" min="0" placeholder=""
                 class="input" v-model.number="requestedFund"/>

        </div>
        <div>
          <a href="#" @click.prevent="updateWithSum()" style="font-size: 12px">☝️ update with categories sum</a>
        </div>
        <div class="help is-danger vrule" rule="required">
          Required.
        </div>
      </div>
    </div>
    <div class="sep-16"></div>
    <div class="gray-sep-light"></div>
    <div class="sep-16"></div>
    <div class="fund-use-input">
      <div class="title-md">
        {{subtitle}}
      </div>
      <div class="sep-16"></div>

      <div class="field" v-for="(item, index) in fundUseList">
        <label :for="'fund-'+index" class="label">{{ item.label }}</label>

        <div class="icon-control ">
          <div class="icon-input">$</div>
          <input :id="'fund-'+index" type="number" vrules="required" min="0" placeholder=""
                 class="input" v-model.number="item.value"/>
        </div>

        <div class="vrule help is-danger" rule="required">
          Required.
        </div>
      </div>


    </div>
  </div>
</template>

<style lang="scss" scoped>
.fund-use-input {
  padding: 0;
}

.fund-use-row {
  margin-bottom: 12px;
}

.percentage-label {
  margin-top: 7px;
}

.row {
  label {
    padding-top: 10px !important;
  }
}

.currency {
  padding-top: 10px;
  font-weight: bold;
}

.vrule {
  padding-top: 10px;
}
</style>
